import React from 'react';

import styles from './UserModule.module.scss';
import UserListLayout from './components/layouts/UserListLayout';
import UserModuleProvider from './UserModuleProvider';

export const UserModule: React.FC<{}> = () => {
  return (
    <UserModuleProvider>
      <UserListLayout className={styles.layout} />
    </UserModuleProvider>
  );
};
